import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxReloadable } from "../../Lib/AxSystem/AxReloadable";
export interface BleQrCodesInit {
    loadTicketBtnClass: string;
    copyTextToClipboardBtnClass: string;

}

declare let toastr: any;

@ModuleName("BleQrCodes")
export class BleQrCodes implements AxInit, AxReloadable {
    private i18nHelper: I18nHelper;
    private initData: BleQrCodesInit;

    AxInit(init: BleQrCodesInit): void {
        this.i18nHelper = new I18nHelper();
        this.initData = init;
        this.initClickEvents('body');
    }

    AxReload(parentName: string): void {
        this.initClickEvents(parentName);
    }

    // initClickEvents
    initClickEvents(parentName: any) {

        $('.imageBox .close, .imageBox').click(() => {
            $('.imageBox').removeClass('open');
            $('.imageBox').removeClass('finished');
            toastr.clear();
            this.toggleOverlayScrollFixed(false);
        });

        let loadTicketButton = $(parentName).find(this.initData.loadTicketBtnClass);

        $(loadTicketButton).click((e) => {
            let cartEntryId = parseInt($(e.currentTarget).attr('data-cartEnrtryId'));
            let orderNr = parseInt($(e.currentTarget).attr('data-orderNr'));
            let mode = parseInt($(e.currentTarget).attr('data-mode'));

            this.loadTicket(orderNr, cartEntryId, mode);
        });

        let copyLinkButton = $(parentName).find(this.initData.copyTextToClipboardBtnClass);

        $(copyLinkButton).click((e) => {
            let cartEntryId = $(e.currentTarget).attr('data-cartEnrtryId');
            this.copyTextToClipboard(`#ble_bc_link_${cartEntryId}`);
        });
    }

    // loadTicket
    loadTicket(orderNr: number, cartEntryId: number, mode: number) {

        $('.imageBox').addClass('open');
        this.toggleOverlayScrollFixed(true);

        let text = [
            this.i18nHelper.GetTranslation(Translations.MyTicketsInfoBarCode),
            this.i18nHelper.GetTranslation(Translations.MyTicketsInfoVoucher),
            this.i18nHelper.GetTranslation(Translations.MyTicketsInfoBLE)
        ];

        let data = {
            orderNr: orderNr,
            cartEntryId: cartEntryId,
        };

        AxessViewer.loadPartialView('/QrCode/ShowTicket', data, resp => {
            if ($('.imageBox').hasClass('open')) {

                $('.imageBox .image').html(resp);

                $('.imageBox .image img').removeAttr('height');

                $('.imageBox').addClass('finished');

                toastr.info(text[mode], null, {
                    "closeButton": false,
                    "debug": false,
                    "newestOnTop": false,
                    "progressBar": false,
                    "positionClass": "toast-bottom-center",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "0",
                    "hideDuration": "1000",
                    "timeOut": "0",
                    "extendedTimeOut": "0",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                });
            }
        }, {
            dataType: 'html'
        });
    }

    // copyTextToClipboard
    copyTextToClipboard(bleBcIdentifierName) {

        let txt = '' + $(bleBcIdentifierName).val();

        navigator.clipboard.writeText(txt);

        toastr.success(this.i18nHelper.GetTranslation(Translations.LinkCopiedToClipboard), null, {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "0",
            "hideDuration": "1000",
            "timeOut": "1000",
            "extendedTimeOut": "0",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        });
    }

    // toggleOverlayScrollFixed
    toggleOverlayScrollFixed(addOverlay) {
        if (addOverlay) {
            var scrollTop = $("html").scrollTop();
            $('html').addClass('overlay');
            $("body").scrollTop(scrollTop);
        }
        else {
            var scrollTop = $("body").scrollTop();
            $('html').removeClass('overlay');
            $("html").scrollTop(scrollTop);
        }
    }
}